import { useEffect, useRef, useState } from 'react';

export const useRotatingTabs = (ids, intervalMs = 6000) => {
  const section = useRef(null);
  const [value, setValue] = useState(ids[0]);
  const [paused, setPaused] = useState(() => window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  const [visible, setVisible] = useState(false);
  const [hidden, setHidden] = useState(document.hidden);
  const [interacting, setInteracting] = useState(false);
  const key = ids.join('|');
  useEffect(() => {
    const node = section.current;
    const observer = new IntersectionObserver(([entry]) => setVisible(entry.isIntersecting), { threshold: 0 });
    if (node) observer.observe(node);
    const visibility = () => setHidden(document.hidden);
    const query = window.matchMedia('(prefers-reduced-motion: reduce)');
    const motion = event => { if (event.matches) setPaused(true); };
    document.addEventListener('visibilitychange', visibility); query.addEventListener('change', motion);
    return () => { observer.disconnect(); document.removeEventListener('visibilitychange', visibility); query.removeEventListener('change', motion); };
  }, []);
  const running = visible && !paused && !hidden && !interacting;
  useEffect(() => {
    if (!running) return;
    const values = key.split('|');
    const timer = window.setTimeout(() => setValue(current => values[(values.indexOf(current) + 1) % values.length]), intervalMs);
    return () => window.clearTimeout(timer);
  }, [key, value, running, intervalMs]);
  const interactionProps = {
    onFocusCapture: () => setInteracting(true),
    onBlurCapture: event => { if (!event.currentTarget.contains(event.relatedTarget)) setInteracting(false); },
  };
  return { section, value, setValue, paused, toggle: () => setPaused(current => !current), running, interactionProps };
};